import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90b4ba00"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-root"
}
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-body" }

import { useGlobalStore } from '@/stores/globalStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const globalStore = useGlobalStore()
const close = () => {
  globalStore.isShowPopup = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_unref(globalStore).isShowPopup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "header"),
                _createElementVNode("button", {
                  onClick: close,
                  class: "close"
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "body")
              ])
            ]),
            _createElementVNode("div", {
              onClick: close,
              class: "bg"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})